module.exports = __webpack_public_path__ + "static/media/red-card.82c43d2d.svg";